export const LIST_OF_KEYS = [
  'provision_description',
  'considered_factors',
  'explanation',
  'date_start',
  'duration',
] as const;
